import escapeStringRegexp from 'escape-string-regexp';
export var regexp = function (r, flags) { return function () {
    var strings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        strings[_i] = arguments[_i];
    }
    return new RegExp(r.replace(/<_>/g, function () { return escapeStringRegexp(strings.shift() || ''); }), flags);
}; };
export var regexpSimple = function (str, flags) { return regexp('<_>', flags)(str); };
//# sourceMappingURL=index.js.map